import { Box, Heading, Paragraph, Text } from '@zillow/constellation-10';
import { SalesProCard } from '../../SharedComponents/SalesProCard';
import renterDataHeader from '../../../img/renterDataHeader.svg';

type RenterDataSidebarProps = {
  areaName: string;
  isNationwide: boolean;
};

const talkingPoints = [
  {
    title: 'Staying within budget is essential',
    description: (
      <>
        Affordability&apos;s the biggest reason renters move <em>and</em> the top reason they don&apos;t.
      </>
    ),
  },
  {
    title: 'Pets are a priority for nearly 2/3 of renters',
    description: 'Communities that welcome furry friends can experience faster leasing activity.',
  },
  {
    title: 'For money matters, be transparent',
    description:
      'Nearly all renters expect to see every fee up front, and most would rather those costs be rolled into a single, predictable number.',
  },
];

export const RenterDataSidebar = ({ areaName, isNationwide }: RenterDataSidebarProps) => {
  const marketDisplayName = isNationwide ? 'your market' : areaName;

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100%',
        gap: '600',
      }}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', padding: '400', paddingBottom: 0 }}>
        <Box css={{ display: 'flex', justifyContent: 'center' }}>
          <img src={renterDataHeader.src} alt="Residents" />
        </Box>
        <Heading level={5}>Attracting &amp; keeping residents</Heading>
        <Paragraph>
          When it comes to attracting and keeping residents, Zillow&apos;s{' '}
          <a
            href="https://www.zillow.com/research/renters-housing-trends-report-2025-35647/"
            target="_blank"
            rel="noopener noreferrer"
          >
            2025 Consumer Housing Trends Report
          </a>{' '}
          shows several factors consistently rise to the top.
        </Paragraph>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '500' }}>
          {talkingPoints.map((point) => (
            <Box key={point.title} css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
              <Text textStyle="body-bold">{point.title}</Text>
              <Paragraph>{point.description}</Paragraph>
            </Box>
          ))}
        </Box>
      </Box>
      <Box css={{ padding: '400', paddingTop: 0 }}>
        <SalesProCard
          title="Tap into renter trends"
          description={`The number of renters in ${marketDisplayName} increased month over month. Does this mean you should adjust your strategy?`}
          buttonText="Connect with [sales pro name]"
        />
      </Box>
    </Box>
  );
};
